import api, { ApiResponse } from './api';

export interface YouTubeVideo {
    id: string;
    title: string;
    description: string;
    publishedAt: string;
    thumbnail: string;
    url: string;
    embedUrl: string;
}

export interface YouTubeVideosResponse {
    channelId: string;
    channelTitle: string;
    channelUrl: string;
    videos: YouTubeVideo[];
    cachedAt: string;
    fromCache: boolean;
}

export const socialApi = {
    getYouTubeVideos: (limit?: number) =>
        api.get<ApiResponse<YouTubeVideosResponse>>('/social/youtube/videos', {
            params: limit ? { limit } : undefined,
        }),
};
